import React, {useEffect, useState} from "react";
import Modal from "react-bootstrap/Modal";
import {useSelector} from "react-redux";
import axios from "axios";
import {toast} from "react-toastify";
import {linkify} from "../constants";
import {isEmpty} from "../../../../../_helpers/commonFunctions";
import moment from "moment";
import {Spinner, Badge} from "react-bootstrap";

const DHPCMessagesModal = ({show, setShow}) => {
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const [loading, setLoading] = useState(false);
    const [dhpcData, setDHPCData] = useState([]);

    useEffect(() => {
        if (show) getMessages();
    }, [show])

    const getMessages = () => {
        setLoading(true);
        axios.get(`${process.env.REACT_APP_API_URL2}/prescription/dhpc-messages`, {
            headers: { "Content-Type": "application/json" },
            params: {
                company: company.id,
            }
        }).then((res) => {
            if (res.data.status === "200") {
                setDHPCData(res.data.data);
            } else {
                toast.error(res.data.message);
            }
            setLoading(false);
        }).catch((err) => {
            console.log(err);
            setLoading(false);
            toast.error("Σφάλμα κατά την άντληση μηνυμάτων.");
        })
    }

    const markRead = (msg) => {
        axios.post(`${process.env.REACT_APP_API_URL2}/prescription/dhpc-mark-read`, {
            company: company.id,
            id: msg.id,
        }, {
            headers: { "Content-Type": "application/json" },
        }).then((res) => {
            if (res.data.status === "200") {
                toast.success("Επιτυχής ανάγνωση μηνύματος.");
                getMessages();
            } else {
                toast.error(res.data.message);
            }
        }).catch((err) => {
            console.log(err);
            toast.error("Σφάλμα κατά την άντληση μηνυμάτων.");
        })
    }

    return (
        <React.Fragment>
            <Modal show={show} onHide={() => setShow(false)} dialogClassName={"modal65PercentWidth"}>
                <Modal.Header closeButton>
                    <Modal.Title>Ενημερώσεις Προς Επαγγελματίες Υγείας</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {show && (
                        <React.Fragment>
                            {loading ? (
                                <div style={{textAlign: "center"}}>Παρακαλώ περιμένετε... <Spinner className={"ml-2"} animation={"border"} variant={"dark"} size={"sm"} /></div>
                            ) : (
                                <div style={{maxHeight: "55vh", overflowY: "auto"}}>
                                    {dhpcData.map((msg, idx) => (
                                        <div key={`dhpc-${idx}`} style={{border: "1px solid lightgray", borderRadius: "8px", padding: "10px", position: "relative"}} className={"mb-1 mr-1"}>
                                            {isEmpty(msg.acknowledged) ? (
                                                <div style={{position: "absolute", right: "10px", top: "10px"}}>
                                                    <Badge bg={"danger"} style={{cursor: "pointer"}} onClick={() => markRead(msg)}>Μαρκάρισμα ως αναγνωσμένο</Badge>
                                                </div>
                                            ) : (
                                                <div style={{position: "absolute", right: "10px", top: "10px"}}>
                                                    <Badge bg={"success"}>Αναγνώστηκε : {moment(msg.acknowledged, "YYYY-MM-DD HH:mm:ss").isValid() ? moment(msg.acknowledged, "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY") : msg.acknowledged}</Badge>
                                                </div>
                                            )}
                                            <div><strong>Τίτλος: </strong> {msg.shortTitle}</div>
                                            <div><strong>Περιεχόμενο: </strong> {linkify(msg.messageUrl)}</div>
                                            {!isEmpty(msg.dateFm) && (
                                                <div style={{textAlign: "right", fontStyle: "italic"}} className={"text-muted"}>
                                                    <span>{moment(msg.dateFm).format("DD/MM/YYYY")}{" "}</span>
                                                    {!isEmpty(msg.dateTo) && (
                                                        <span>- {moment(msg.dateTo).format("DD/MM/YYYY")}</span>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            )}
                        </React.Fragment>
                    )}
                </Modal.Body>
            </Modal>
        </React.Fragment>
    )
}

export default DHPCMessagesModal;
